function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.83264,
  cy: 8.87766,
  rx: 7.16602,
  ry: 7.21104,
  stroke: "url(#paint0_linear)",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M18.3849 19.546C18.1065 19.537 17.8418 19.4225 17.6438 19.2254L15.9468 17.2418C15.583 16.9091 15.5532 16.3436 15.8801 15.9741C16.0331 15.8192 16.2412 15.7322 16.4581 15.7322C16.6751 15.7322 16.8832 15.8192 17.0362 15.9741L19.1704 17.6818C19.4778 17.9964 19.5727 18.4635 19.4126 18.8743C19.2525 19.2851 18.8674 19.5628 18.4294 19.5833L18.3849 19.546Z",
  fill: "url(#paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 8.83264,
  y1: 1.66663,
  x2: 8.83264,
  y2: 16.0887,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0078FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00ACFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 17.5713,
  y1: 15.7322,
  x2: 17.5713,
  y2: 19.5833,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0078FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00ACFF"
})));

function SvgSelectedSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedSearch);
export default __webpack_public_path__ + "static/media/SelectedSearch.c83091b8.svg";
export { ForwardRef as ReactComponent };